(function () {
  const roots = document.querySelectorAll('[data-dealer-locator]');
  const provinceNames = { AB: 'Alberta', BC: 'British Columbia', MB: 'Manitoba', NT: 'Northwest Territories', ON: 'Ontario', SK: 'Saskatchewan' };
  const cityProvinces = {
    barrie: 'ON', brantford: 'ON', cambridge: 'ON', kitchener: 'ON', oakville: 'ON', toronto: 'ON', waterloo: 'ON',
    altona: 'MB', macgregor: 'MB', neepawa: 'MB', 'the pas': 'MB', winnipeg: 'MB',
    assiniboia: 'SK', estevan: 'SK', humboldt: 'SK', kindersley: 'SK', lloydminster: 'SK', 'moose jaw': 'SK', regina: 'SK', saskatoon: 'SK', tisdale: 'SK', yorkton: 'SK',
    'hay river': 'NT', yellowknife: 'NT',
    barrhead: 'AB', blairmore: 'AB', brooks: 'AB', calgary: 'AB', camrose: 'AB', cardston: 'AB', cochrane: 'AB', edmonton: 'AB', edson: 'AB', 'fort mcmurray': 'AB', 'grande prairie': 'AB', 'high level': 'AB', 'medicine hat': 'AB', taber: 'AB', whitecourt: 'AB',
    castlegar: 'BC', chilliwack: 'BC', courtenay: 'BC', 'dawson creek': 'BC', gibsons: 'BC', invermere: 'BC', kamloops: 'BC', kelowna: 'BC', langley: 'BC', merritt: 'BC', nelson: 'BC', peachland: 'BC', penticton: 'BC', 'prince george': 'BC', 'prince rupert': 'BC', 'qualicum beach': 'BC', quesnel: 'BC', revelstoke: 'BC', 'salmon arm': 'BC', smithers: 'BC', terrace: 'BC', vancouver: 'BC', vernon: 'BC', 'west kelowna': 'BC', 'williams lake': 'BC'
  };

  function clean(value) {
    return String(value || '').trim();
  }

  function normalizeText(value) {
    return clean(value).toLocaleLowerCase('en-CA').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  function dealerProvince(dealer) {
    if (provinceNames[dealer.province]) return dealer.province;
    const postal = clean(dealer.postal).toUpperCase();
    const postalProvince = { V: 'BC', T: 'AB', S: 'SK', R: 'MB', X: 'NT', P: 'ON', N: 'ON', L: 'ON', M: 'ON', K: 'ON' }[postal.charAt(0)];
    if (postalProvince) return postalProvince;
    const text = normalizeText([dealer.city, dealer.address].join(' '));
    const city = Object.keys(cityProvinces).find(function (name) { return text.includes(name); });
    return city ? cityProvinces[city] : '';
  }

  function haversine(origin, dealer) {
    const radius = 6371;
    const toRadians = function (degrees) { return degrees * Math.PI / 180; };
    const latDelta = toRadians(dealer.lat - origin.lat);
    const lngDelta = toRadians(dealer.lng - origin.lng);
    const a = Math.sin(latDelta / 2) ** 2 + Math.cos(toRadians(origin.lat)) * Math.cos(toRadians(dealer.lat)) * Math.sin(lngDelta / 2) ** 2;
    return radius * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function addressText(dealer) {
    const values = [dealer.address, dealer.city, dealer.province, dealer.postal].filter(Boolean);
    return values.join(', ').replace(/,\s*,/g, ',');
  }

  function project(lat, lng, zoom) {
    const scale = 256 * (2 ** zoom);
    const safeLat = Math.max(-85.05112878, Math.min(85.05112878, lat));
    const sin = Math.sin(safeLat * Math.PI / 180);
    return {
      x: (lng + 180) / 360 * scale,
      y: (0.5 - Math.log((1 + sin) / (1 - sin)) / (4 * Math.PI)) * scale
    };
  }

  function unproject(x, y, zoom) {
    const scale = 256 * (2 ** zoom);
    const lng = x / scale * 360 - 180;
    const n = Math.PI - 2 * Math.PI * y / scale;
    return { lat: 180 / Math.PI * Math.atan(0.5 * (Math.exp(n) - Math.exp(-n))), lng: lng };
  }

  function init(root) {
    const data = Array.isArray(window.RiseSleepDealerData) ? window.RiseSleepDealerData.slice() : [];
    const search = root.querySelector('[data-locator-search]');
    const province = root.querySelector('[data-locator-province]');
    const near = root.querySelector('[data-locator-near]');
    const reset = root.querySelector('[data-locator-reset]');
    const emptyReset = root.querySelector('[data-locator-empty-reset]');
    const status = root.querySelector('[data-locator-status]');
    const results = root.querySelector('[data-locator-results]');
    const count = root.querySelector('[data-locator-count]');
    const empty = root.querySelector('[data-locator-empty]');
    const template = root.querySelector('[data-dealer-card-template]');
    const map = root.querySelector('[data-locator-map]');
    const tileLayer = root.querySelector('[data-map-tiles]');
    const markerLayer = root.querySelector('[data-map-markers]');
    const state = { center: { lat: 53.8, lng: -108.5 }, zoom: 4, origin: null, selectedId: null, dragging: null, fitted: false };
    let filtered = [];
    let renderFrame = 0;

    data.forEach(function (dealer) {
      dealer.province = dealerProvince(dealer);
      dealer.searchText = normalizeText([dealer.name, dealer.address, dealer.city, dealer.province, provinceNames[dealer.province], dealer.postal].join(' '));
    });

    function visibleDealers() {
      const query = normalizeText(search.value);
      const selectedProvince = province.value;
      const matches = data.filter(function (dealer) {
        return (!query || dealer.searchText.includes(query)) && (!selectedProvince || dealer.province === selectedProvince);
      });
      if (state.origin) {
        matches.forEach(function (dealer) { dealer.distance = haversine(state.origin, dealer); });
        matches.sort(function (a, b) { return a.distance - b.distance; });
      } else {
        matches.sort(function (a, b) { return a.name.localeCompare(b.name, 'en-CA'); });
      }
      return matches;
    }

    function mapGeometry() {
      const centerPixel = project(state.center.lat, state.center.lng, state.zoom);
      return {
        width: map.clientWidth,
        height: map.clientHeight,
        centerPixel: centerPixel,
        left: centerPixel.x - map.clientWidth / 2,
        top: centerPixel.y - map.clientHeight / 2
      };
    }

    function renderTiles(geometry) {
      const tileSize = 256;
      const tileCount = 2 ** state.zoom;
      const minX = Math.floor(geometry.left / tileSize);
      const maxX = Math.floor((geometry.left + geometry.width) / tileSize);
      const minY = Math.max(0, Math.floor(geometry.top / tileSize));
      const maxY = Math.min(tileCount - 1, Math.floor((geometry.top + geometry.height) / tileSize));
      const fragment = document.createDocumentFragment();
      for (let y = minY; y <= maxY; y += 1) {
        for (let x = minX; x <= maxX; x += 1) {
          const wrappedX = ((x % tileCount) + tileCount) % tileCount;
          const image = document.createElement('img');
          image.src = 'https://tile.openstreetmap.org/' + state.zoom + '/' + wrappedX + '/' + y + '.png';
          image.alt = '';
          image.decoding = 'async';
          image.draggable = false;
          image.style.left = (x * tileSize - geometry.left) + 'px';
          image.style.top = (y * tileSize - geometry.top) + 'px';
          fragment.appendChild(image);
        }
      }
      tileLayer.replaceChildren(fragment);
    }

    function markerButton(className, left, top, label) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = className;
      button.style.left = left + 'px';
      button.style.top = top + 'px';
      button.setAttribute('aria-label', label);
      return button;
    }

    function selectDealer(dealer, moveMap) {
      state.selectedId = dealer.id;
      if (moveMap) {
        state.center = { lat: dealer.lat, lng: dealer.lng };
        state.zoom = Math.max(state.zoom, 9);
      }
      renderAll();
      const activeCard = results.querySelector('[data-dealer-id="' + dealer.id + '"]');
      if (activeCard) activeCard.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    function renderMarkers(geometry) {
      const groups = new Map();
      const cellSize = state.zoom <= 6 ? 46 : 24;
      filtered.forEach(function (dealer) {
        const point = project(dealer.lat, dealer.lng, state.zoom);
        const left = point.x - geometry.left;
        const top = point.y - geometry.top;
        if (left < -30 || top < -30 || left > geometry.width + 30 || top > geometry.height + 30) return;
        const key = Math.floor(left / cellSize) + ':' + Math.floor(top / cellSize);
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push({ dealer: dealer, left: left, top: top });
      });
      const fragment = document.createDocumentFragment();
      groups.forEach(function (items) {
        if (items.length > 1 && state.zoom <= 7) {
          const average = items.reduce(function (sum, item) {
            sum.left += item.left;
            sum.top += item.top;
            sum.lat += item.dealer.lat;
            sum.lng += item.dealer.lng;
            return sum;
          }, { left: 0, top: 0, lat: 0, lng: 0 });
          const cluster = markerButton('rs-map-marker rs-map-marker--cluster', average.left / items.length, average.top / items.length, 'Zoom in to view ' + items.length + ' dealers');
          cluster.textContent = items.length;
          cluster.addEventListener('click', function () {
            state.center = { lat: average.lat / items.length, lng: average.lng / items.length };
            state.zoom = Math.min(14, state.zoom + 2);
            renderAll();
          });
          fragment.appendChild(cluster);
        } else {
          items.forEach(function (item) {
            const marker = markerButton('rs-map-marker', item.left, item.top, item.dealer.name);
            marker.title = item.dealer.name;
            if (item.dealer.id === state.selectedId) marker.setAttribute('data-active', 'true');
            marker.addEventListener('click', function () { selectDealer(item.dealer, false); });
            fragment.appendChild(marker);
          });
        }
      });
      if (state.origin) {
        const userPoint = project(state.origin.lat, state.origin.lng, state.zoom);
        const user = markerButton('rs-map-marker rs-map-marker--user', userPoint.x - geometry.left, userPoint.y - geometry.top, 'Your location');
        user.disabled = true;
        fragment.appendChild(user);
      }
      markerLayer.replaceChildren(fragment);
    }

    function renderResults() {
      const fragment = document.createDocumentFragment();
      filtered.forEach(function (dealer) {
        const card = template.content.firstElementChild.cloneNode(true);
        card.dataset.dealerId = dealer.id;
        if (dealer.id === state.selectedId) card.setAttribute('data-active', 'true');
        card.querySelector('[data-card-province]').textContent = provinceNames[dealer.province] || 'Canada';
        card.querySelector('[data-card-name]').textContent = dealer.name;
        card.querySelector('[data-card-address]').textContent = addressText(dealer);
        const distance = card.querySelector('[data-card-distance]');
        if (state.origin && Number.isFinite(dealer.distance)) {
          distance.textContent = Math.round(dealer.distance) + ' km';
          distance.hidden = false;
        }
        const directions = card.querySelector('[data-card-directions]');
        directions.href = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(addressText(dealer) || dealer.lat + ',' + dealer.lng);
        directions.setAttribute('aria-label', 'Directions to ' + dealer.name);
        const phone = card.querySelector('[data-card-phone]');
        if (dealer.phone) {
          phone.textContent = dealer.phone;
          phone.href = 'tel:' + dealer.phone.replace(/[^\d+]/g, '');
          phone.hidden = false;
        }
        const website = card.querySelector('[data-card-website]');
        if (dealer.website) {
          website.href = dealer.website;
          website.setAttribute('aria-label', dealer.name + ' website');
          website.hidden = false;
        }
        card.querySelector('[data-card-select]').addEventListener('click', function () { selectDealer(dealer, true); });
        fragment.appendChild(card);
      });
      results.replaceChildren(fragment);
      empty.hidden = filtered.length !== 0;
      results.hidden = filtered.length === 0;
      count.textContent = filtered.length === data.length ? data.length + ' dealers across Canada' : filtered.length + ' dealer' + (filtered.length === 1 ? '' : 's') + ' found';
    }

    function renderMap() {
      if (!map.clientWidth || !map.clientHeight) return;
      const geometry = mapGeometry();
      renderTiles(geometry);
      renderMarkers(geometry);
    }

    function renderAll() {
      filtered = visibleDealers();
      renderResults();
      renderMap();
    }

    function fitDealers(dealers) {
      if (!dealers.length || !map.clientWidth || !map.clientHeight) return;
      let chosenZoom = 3;
      let chosenCenter = { lat: dealers[0].lat, lng: dealers[0].lng };
      for (let zoom = 14; zoom >= 3; zoom -= 1) {
        const points = dealers.map(function (dealer) { return project(dealer.lat, dealer.lng, zoom); });
        const xs = points.map(function (point) { return point.x; });
        const ys = points.map(function (point) { return point.y; });
        const minX = Math.min.apply(null, xs);
        const maxX = Math.max.apply(null, xs);
        const minY = Math.min.apply(null, ys);
        const maxY = Math.max.apply(null, ys);
        if (maxX - minX <= map.clientWidth - 90 && maxY - minY <= map.clientHeight - 90) {
          chosenZoom = zoom;
          chosenCenter = unproject((minX + maxX) / 2, (minY + maxY) / 2, zoom);
          break;
        }
      }
      state.zoom = chosenZoom;
      state.center = chosenCenter;
    }

    function refine() {
      state.selectedId = null;
      filtered = visibleDealers();
      fitDealers(filtered);
      renderResults();
      renderMap();
    }

    function changeZoom(amount) {
      state.zoom = Math.max(3, Math.min(15, state.zoom + amount));
      renderMap();
    }

    function panBy(x, y) {
      const centerPixel = project(state.center.lat, state.center.lng, state.zoom);
      state.center = unproject(centerPixel.x + x, centerPixel.y + y, state.zoom);
      renderMap();
    }

    search.addEventListener('input', refine);
    province.addEventListener('change', refine);
    root.querySelector('[data-locator-form]').addEventListener('submit', function (event) { event.preventDefault(); });
    root.querySelector('[data-map-zoom-in]').addEventListener('click', function () { changeZoom(1); });
    root.querySelector('[data-map-zoom-out]').addEventListener('click', function () { changeZoom(-1); });

    function resetLocator() {
      search.value = '';
      province.value = '';
      state.origin = null;
      state.selectedId = null;
      near.removeAttribute('data-active');
      status.textContent = '';
      filtered = visibleDealers();
      fitDealers(filtered);
      renderAll();
    }

    reset.addEventListener('click', resetLocator);
    emptyReset.addEventListener('click', resetLocator);

    near.addEventListener('click', function () {
      if (!navigator.geolocation) {
        status.textContent = 'Location services are not available in this browser.';
        return;
      }
      near.disabled = true;
      status.textContent = 'Finding your location…';
      navigator.geolocation.getCurrentPosition(function (position) {
        state.origin = { lat: position.coords.latitude, lng: position.coords.longitude };
        state.center = state.origin;
        state.zoom = 8;
        state.selectedId = null;
        near.disabled = false;
        near.setAttribute('data-active', 'true');
        status.textContent = 'Showing dealers nearest to your current location.';
        renderAll();
      }, function () {
        near.disabled = false;
        status.textContent = 'We could not access your location. Search by city or postal code instead.';
      }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 });
    });

    map.addEventListener('pointerdown', function (event) {
      if (event.target.closest('button, a')) return;
      const centerPixel = project(state.center.lat, state.center.lng, state.zoom);
      state.dragging = { x: event.clientX, y: event.clientY, centerPixel: centerPixel };
      map.setPointerCapture(event.pointerId);
      map.setAttribute('data-dragging', 'true');
    });

    map.addEventListener('pointermove', function (event) {
      if (!state.dragging) return;
      const x = event.clientX - state.dragging.x;
      const y = event.clientY - state.dragging.y;
      tileLayer.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      markerLayer.style.transform = 'translate(' + x + 'px,' + y + 'px)';
    });

    function finishDrag(event) {
      if (!state.dragging) return;
      const x = event.clientX - state.dragging.x;
      const y = event.clientY - state.dragging.y;
      state.center = unproject(state.dragging.centerPixel.x - x, state.dragging.centerPixel.y - y, state.zoom);
      state.dragging = null;
      tileLayer.style.transform = '';
      markerLayer.style.transform = '';
      map.removeAttribute('data-dragging');
      renderMap();
    }

    map.addEventListener('pointerup', finishDrag);
    map.addEventListener('pointercancel', finishDrag);
    map.addEventListener('wheel', function (event) {
      event.preventDefault();
      changeZoom(event.deltaY < 0 ? 1 : -1);
    }, { passive: false });

    map.addEventListener('keydown', function (event) {
      const keyActions = {
        ArrowUp: function () { panBy(0, -80); },
        ArrowDown: function () { panBy(0, 80); },
        ArrowLeft: function () { panBy(-80, 0); },
        ArrowRight: function () { panBy(80, 0); },
        '+': function () { changeZoom(1); },
        '=': function () { changeZoom(1); },
        '-': function () { changeZoom(-1); }
      };
      if (keyActions[event.key]) {
        event.preventDefault();
        keyActions[event.key]();
      }
    });

    const resizeObserver = new ResizeObserver(function () {
      cancelAnimationFrame(renderFrame);
      renderFrame = requestAnimationFrame(function () {
        if (!state.fitted) {
          filtered = visibleDealers();
          fitDealers(filtered);
          state.fitted = true;
        }
        renderAll();
      });
    });
    resizeObserver.observe(map);
  }

  roots.forEach(init);
}());
